import actions from '../actions/FavoritesActions';

const {
    RESET_CREATION_STATE,
    SET_PORTFOLIO_DESCRIPTION,
    SET_NEW_PORTFOLIO_NAME,
    SET_PORTFOLIO_PRIVACY,
    SET_NOTE,
    SET_NOTE_IMAGE,
    SET_NOTE_TITLE,
} = actions;

const creationState = (state = {}, payload) => {
    switch (payload.type) {
        case RESET_CREATION_STATE:
            return {
                newPortfolioDescription: '',
                newPortfolioName: '',
                newPortfolioPrivacy: 'PUBLIC',
                note: '',
                noteImage: '',
                noteTitle: '',
            };
        case SET_PORTFOLIO_DESCRIPTION:
            return { ...state, newPortfolioDescription: payload.newPortfolioDescription };
        case SET_NEW_PORTFOLIO_NAME:
            return { ...state, newPortfolioName: payload.newPortfolioName };
        case SET_PORTFOLIO_PRIVACY:
            return { ...state, newPortfolioPrivacy: payload.newPortfolioPrivacy };
        case SET_NOTE:
            return { ...state, note: payload.note };
        case SET_NOTE_IMAGE:
            return { ...state, noteImage: payload.noteImage };
        case SET_NOTE_TITLE:
            return { ...state, noteTitle: payload.noteTitle };
        default:
            return state;
    }
};

export default creationState;
